<mat-slide-toggle
  class="app-toggle"
  color="secondary"
  [checked]="checked()"
  (change)="onToggle($event.checked)"
>
</mat-slide-toggle>
